export function deleteItem(item, uuid) {
  if (item.check_conditions_for && item.check_conditions_for.length) {
    for (const i in item.check_conditions_for) {
      if (item.check_conditions_for[i] === uuid) {
        item.check_conditions_for.splice(i, 1);
      }
    }
  }

  if (item.items && item.items.length > 0) {
    for (const j in item.items) {
      if (item.items[j].uuid === uuid) {
        // for docs here, we never remove image_id from assets with response
        // because it might have been used already in conducted inspection
        item.items.splice(j, 1);
      } else {
        deleteItem(item.items[j], uuid);
      }
    }
  }
}
